import get from 'lodash/get';

import MessageFlowMessage from './MessageFlowMessage';

const defaultProps = {
  /* Whether this message flow is completed */
  complete: false,
  /* The automated messages in this message flow */
  messages: [],
  /* The name for the automated flow */
  name: '',
  /**
   * Dictionary mapping of where to find responses for messages in the flow
   * uses a string key with a int value relating to the message order of the message
   * to find the response
   */
  responseMap: {}
};

const convertInternal = (whMessageFlow) => {
  return {
    complete: whMessageFlow.complete || defaultProps.complete,
    messages: get(whMessageFlow, 'messages', []).map(message =>
      MessageFlowMessage.createFromWarehouseResponse({
        whMessageFlowMessage: message
      })) || defaultProps.messages,
    name: whMessageFlow.name || defaultProps.name,
    responseMap: whMessageFlow.responseMap || defaultProps.responseMap
  };
};

class MessageFlow {
  /**
   * Creates a new MessageFlow based on the server response
   * @argument whMessageFlow: the raw message flow data from the server response
   */
  static createFromWarehouseResponse ({ whMessageFlow }) {
    return new MessageFlow({
      ...convertInternal(whMessageFlow)
    });
  }

  /** Creates a new MessageFlow
   * @argument fields: The attributes to add to this instance
   */
  constructor (fields = defaultProps) {
    Object.assign(this, fields);
  }

  /** Generates a copy of the MessageFlow instance
   * @argument overrides: The attributes to add to the new instance
  */
  makeCopy (overrides) {
    return new MessageFlow({
      complete: this.complete,
      messages: [...this.messages],
      name: this.name,
      responseMap: { ...this.responseMap },
      ...overrides
    });
  }
}

export default MessageFlow;
